import React from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import { graphql, useStaticQuery } from 'gatsby';
import usIcon from '../../images/individuals/long-term/usIcon.png';
import hkIcon from '../../images/individuals/long-term/hkIcon.png';
import cnIcon from '../../images/individuals/long-term/cnIcon.png';

const ActiveApproach = ({ data, img }) => {
  const imgData = useStaticQuery(graphql`
    query {
      GlobalTechGiants: file(
        relativePath: {
          eq: "individuals/active-approach/Global-Tech-Giants.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ProfitMakers: file(
        relativePath: { eq: "individuals/active-approach/Profit-Makers.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      BusinessWinners: file(
        relativePath: { eq: "individuals/active-approach/Business-Winners.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ChineseTechStars: file(
        relativePath: {
          eq: "individuals/active-approach/Chinese-Tech-Stars.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      QualityBlueChips: file(
        relativePath: {
          eq: "individuals/active-approach/Quality-Blue-Chips.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HiddenGems: file(
        relativePath: { eq: "individuals/active-approach/Hidden-Gems.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HighDividends: file(
        relativePath: { eq: "individuals/active-approach/High-Dividends.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      PropertyMoguls: file(
        relativePath: { eq: "individuals/active-approach/Property-Moguls.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      USMarketLeaders: file(
        relativePath: {
          eq: "individuals/active-approach/US-Market-Leaders.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HealthIsWealth: file(
        relativePath: { eq: "individuals/active-approach/Health-Is-Wealth.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HongKongMarketLeaders: file(
        relativePath: {
          eq: "individuals/active-approach/Hong-Kong-Market-Leaders.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ABetterWorld: file(
        relativePath: { eq: "individuals/active-approach/A-Better-World.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ESGHK: file(
        relativePath: { eq: "individuals/active-approach/ESG-HK.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  // 从传进来的imgURL中截出imgName并转成驼峰命名形式
  const imgName = img
    .slice(img.lastIndexOf('/') + 1, img.lastIndexOf('.'))
    .replace(/-/g, '');
  const intl = useIntl();
  const iconName = intl.formatMessage({ id: `${data}.region` });
  const regionIcon = {
    US: usIcon,
    HK: hkIcon,
    CN: cnIcon,
  };
  return (
    <div
      css={css`
        position: relative;
        border-radius: 20px;
        text-align: left;
        background: ${`url(${imgData[imgName].childImageSharp.fluid.src})`}
          center/auto 100% no-repeat border-box border-box;
        background-size: cover;
        width: 253px;
        height: 202px;
        margin-right: 24px;
        ${Tablet} {
          margin-right: 24px;
        }

        ${Desktop} {
          width: 365px;
          height: 292.2px;
          margin-right: 0;
        }
      `}
    >
      <div
        css={css`
          position: relative;
          border-radius: 20px;
          width: 253px;
          height: 202px;
          padding: 29px 29px 91px 17px;
          background-image: linear-gradient(
            93deg,
            #030303 -113%,
            rgba(55, 55, 55, 0.54) -9%,
            rgba(0, 0, 0, 0.08) 98%
          );
          ${Tablet} {
          }
          ${Desktop} {
            width: 365px;
            height: 292.2px;
            padding: 34.7px 30px 159.5px 30px;
          }
        `}
      >
        <img
          css={css`
            height: 20px;
            ${Tablet} {
              height: 20px;
            }
            ${Desktop} {
              height: 21px;
            }
          `}
          src={regionIcon[iconName]}
        ></img>
        <span
          css={css`
            display: block;
            color: #ffffff;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            text-align: left;

            max-width: 200px;
            font-size: 20px;
            margin: 5.3px 3px 4.7px 0;
            line-height: 1.5;
            white-space: normal;

            ${Desktop} {
              max-width: 100%;
              font-size: 30px;
              margin: 10.3px 0 9.7px;
              line-height: 1;
            }
          `}
        >
          <FormattedHTMLMessage id={`${data}.title`} />
        </span>
        <span
          css={css`
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: normal;
            text-align: left;
            color: #ffffff;

            max-width: 189px;
            margin: 4.9px 0 0;
            font-size: 16px;
            ${Desktop} {
              max-width: 215px;
              margin: 4.9px 0px 0 0;
              font-size: 20px;
            }
          `}
        >
          <FormattedHTMLMessage id={`${data}.description`} />
        </span>
      </div>
    </div>
  );
};

export default ActiveApproach;
